"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.animatedScrollToY = exports.animatedScrollToX = void 0;
var DEFAULT_DURATION = 300;
// https://css-tricks.com/emulating-css-timing-functions-javascript/
var tfs = {
    linear: function (t) { return t; },
    // eslint-disable-next-line
    easeIn: function (t) { return Math.pow(t, 1.675); },
    // eslint-disable-next-line
    easeOut: function (t) { return 1 - Math.pow(1 - t, 1.675); },
    easeInOut: function (t) { return 0.5 * (Math.sin((t - 0.5) * Math.PI) + 1); },
};
/**
 * Плавная прокрутка по горизонтали
 * @param {Element} elem
 * @param {number} pos
 * @param {number} duration
 * @param {string} timingFunction
 */
exports.animatedScrollToX = function (elem, pos, duration, timingFunction) {
    if (duration === void 0) { duration = DEFAULT_DURATION; }
    if (timingFunction === void 0) { timingFunction = 'easeInOut'; }
    var startTime;
    var startX = elem.scrollLeft;
    var endX = Math.max(0, Math.min(elem.scrollWidth - elem.clientWidth, pos));
    var handleNewAnimationFrame = function () {
        startTime = startTime || Date.now();
        var timePos = Math.min(1, Math.max(1, Date.now() - startTime) / duration);
        var scrollPos = tfs[timingFunction](timePos);
        var left = startX + (endX - startX) * scrollPos;
        elem.scrollTo({ left: left });
        if (timePos !== 1)
            window.requestAnimationFrame(handleNewAnimationFrame);
    };
    window.requestAnimationFrame(handleNewAnimationFrame);
};
/**
 * Плавная прокрутка по вертикали
 * @param {Element} elem
 * @param {number} pos
 * @param {number} duration
 * @param {string} timingFunction
 */
exports.animatedScrollToY = function (elem, pos, duration, timingFunction) {
    if (duration === void 0) { duration = DEFAULT_DURATION; }
    if (timingFunction === void 0) { timingFunction = 'easeInOut'; }
    var startTime;
    var startY = elem.scrollTop;
    var endY = Math.max(0, Math.min(elem.scrollHeight - elem.clientHeight, pos));
    var handleNewAnimationFrame = function () {
        startTime = startTime || Date.now();
        var timePos = Math.min(1, Math.max(1, Date.now() - startTime) / duration);
        var scrollPos = tfs[timingFunction](timePos);
        var top = startY + (endY - startY) * scrollPos;
        elem.scrollTo({ top: top });
        if (timePos !== 1)
            window.requestAnimationFrame(handleNewAnimationFrame);
    };
    window.requestAnimationFrame(handleNewAnimationFrame);
};
//# sourceMappingURL=animatedScrollTo.js.map